var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import React from 'react';
import { Form, FormGroup, Label, Input, Button, InputGroup, InputGroupAddon, InputGroupText, FormFeedback } from 'reactstrap';
import { FormattedMessage, injectIntl } from 'react-intl';
import { createErrorResponse, notifyUncaughtErrors } from '../../../utils/errorUtils';
import Page from '../Page';
import { ApplicationContext } from '../../../ApplicationContext';
import { FormErrorContext } from '../../../FormErrorContext';
import FormField from '../../components/ui/FormField/FormField';
import { Link } from 'react-router-dom';
import Routes from '../../../routes/RoutesConfig';
import CreateUserCommand from '../../../commands/users/CreateUserCommand';
import UserModel from '../../../models/UserModel';
import PasswordValidator, { validPassword } from '../../components/ui/PasswordValidator/PasswordValidator';
import Signals from '../../../signals/Signals';
import withRouter from "../../components/ui/MainNavigation/withRouter";
/**
 *
 */
var ForgotPassword = /** @class */ (function (_super) {
    __extends(ForgotPassword, _super);
    /**
     *
     */
    function ForgotPassword(props) {
        var _this = _super.call(this, props) || this;
        _this.state = {
            errors: null,
            username: undefined,
            submitting: false,
            showPassword: false,
            passwordMatch: "",
            showMatchingPassword: false,
            matchingPasswords: false
        };
        _this.onSubmit = _this.onSubmit.bind(_this);
        _this.onInputChange = _this.onInputChange.bind(_this);
        _this.onError = _this.onError.bind(_this);
        _this.onSuccess = _this.onSuccess.bind(_this);
        return _this;
    }
    /**
     *
     * @param prevProps
     * @param prevState
     * @param snapshot
     */
    ForgotPassword.prototype.componentDidUpdate = function (prevProps, prevState, snapshot) {
        notifyUncaughtErrors(this.state, this.props.intl, ["password", "passwordMatch"]);
    };
    /**
     *
     * @returns {*}
     */
    ForgotPassword.prototype.render = function () {
        var _this = this;
        var _a, _b, _c, _d, _e, _f, _g, _h;
        return (React.createElement(Page, { pageName: "create-account" },
            React.createElement("div", { className: "container h-100 align-items-center" },
                React.createElement("div", { className: "row justify-content-center align-items-center h-100" },
                    React.createElement("div", { className: "col-md-6 col-lg-5 text-white pt-5 h-100" },
                        React.createElement("h2", { className: "card-header justify-content-center" },
                            React.createElement(FormattedMessage, { id: "page.createaccount.title" })),
                        React.createElement("div", { className: "card-body h-75 overflow-auto", style: { fontSize: "large" } },
                            React.createElement(FormErrorContext.Provider, { value: { errors: this.state.errors } },
                                React.createElement(Form, { onSubmit: this.onSubmit },
                                    React.createElement("fieldset", { disabled: this.state.submitting },
                                        React.createElement(FormGroup, null,
                                            React.createElement(FormField, { className: "justify-content-center" },
                                                React.createElement(Label, { for: "firstName" },
                                                    React.createElement(FormattedMessage, { id: "page.createaccount.field.firstname" })),
                                                React.createElement(Input, { name: "firstname", id: "firstname", onChange: this.onInputChange, required: true }))),
                                        React.createElement(FormGroup, null,
                                            React.createElement(FormField, { className: "justify-content-center" },
                                                React.createElement(Label, { for: "lastname" },
                                                    React.createElement(FormattedMessage, { id: "page.createaccount.field.lastname" })),
                                                React.createElement(Input, { name: "lastname", id: "lastname", onChange: this.onInputChange, required: true }))),
                                        React.createElement(FormGroup, null,
                                            React.createElement(FormField, { className: "justify-content-center" },
                                                React.createElement(Label, { for: "email" },
                                                    React.createElement(FormattedMessage, { id: "page.createaccount.field.email" })),
                                                React.createElement(Input, { name: "email", id: "email", type: "email", onChange: this.onInputChange, required: true }))),
                                        React.createElement(FormGroup, null,
                                            React.createElement(FormField, { className: "justify-content-center" },
                                                React.createElement(Label, { for: "password" },
                                                    React.createElement(FormattedMessage, { id: "page.createaccount.field.password" })),
                                                React.createElement(InputGroup, null,
                                                    React.createElement(Input, { name: "password", id: "password", invalid: ((_b = (_a = this.state.errors) === null || _a === void 0 ? void 0 : _a['password']) === null || _b === void 0 ? void 0 : _b.length) > 0, type: this.state.showPassword ? "text" : "password", autoComplete: "new-password", onChange: this.onInputChange }),
                                                    React.createElement(InputGroupAddon, { addonType: 'append' },
                                                        React.createElement(InputGroupText, { className: "showPasswordButton " + ((!this.state.matchingPasswords && this.state.password) ? "active" : "") },
                                                            React.createElement("span", { onClick: function () {
                                                                    _this.setState({ showPassword: !_this.state.showPassword });
                                                                    _this.checkIfPasswordsMatch(_this.state.password, _this.state.passwordMatch);
                                                                }, className: "fe cursor-pointer " + (this.state.showPassword ? "fe-eye" : "fe-eye-off") }))), (_d = (_c = this.state.errors) === null || _c === void 0 ? void 0 : _c['password']) === null || _d === void 0 ? void 0 :
                                                    _d.map(function (e) {
                                                        return (React.createElement(FormFeedback, { className: "", invalid: true },
                                                            React.createElement(FormattedMessage, { id: e })));
                                                    })))),
                                        React.createElement(FormGroup, null,
                                            React.createElement(FormField, { className: "justify-content-center" },
                                                React.createElement(Label, { for: "passwordMatch" },
                                                    React.createElement(FormattedMessage, { id: "page.acceptinvitation.field.passwordMatch" })),
                                                React.createElement(InputGroup, null,
                                                    React.createElement(Input, { name: "passwordMatch", id: "passwordMatch", invalid: ((_f = (_e = this.state.errors) === null || _e === void 0 ? void 0 : _e['passwordMatch']) === null || _f === void 0 ? void 0 : _f.length) > 0, type: this.state.showMatchingPassword ? "text" : "password", autoComplete: "new-password", required: true, onChange: this.onInputChange }),
                                                    React.createElement(InputGroupAddon, { addonType: 'append' },
                                                        React.createElement(InputGroupText, { className: "showPasswordButton " + ((!this.state.matchingPasswords && this.state.password) ? "active" : "") },
                                                            React.createElement("span", { onClick: function () {
                                                                    _this.setState({ showMatchingPassword: !_this.state.showMatchingPassword });
                                                                    _this.checkIfPasswordsMatch(_this.state.password, _this.state.passwordMatch);
                                                                }, className: "fe cursor-pointer " + (this.state.showMatchingPassword ? "fe-eye" : "fe-eye-off") }))), (_h = (_g = this.state.errors) === null || _g === void 0 ? void 0 : _g['passwordMatch']) === null || _h === void 0 ? void 0 :
                                                    _h.map(function (e) {
                                                        return (React.createElement(FormFeedback, { className: "text-white rounded bg-danger py-2 px-3", invalid: true },
                                                            React.createElement(FormattedMessage, { id: e })));
                                                    })))),
                                        React.createElement(PasswordValidator, { value: this.state['password'] }),
                                        React.createElement(Button, { className: "w-100 ml-0 mb-3 font-weight-bolder", color: "dark", type: "submit", style: { fontSize: "large" } },
                                            this.fieldsComplete() ?
                                                React.createElement("i", { className: "fe fe-user-check mr-2" }) :
                                                React.createElement("i", { className: "fe fe-user mr-2" }),
                                            React.createElement(FormattedMessage, { id: "page.createaccount.register" })),
                                        React.createElement("p", { className: "text-center" },
                                            React.createElement("small", { className: "text-center" },
                                                React.createElement(FormattedMessage, { id: "page.createaccount.alreadyaccount" }),
                                                React.createElement(Link, { to: Routes.LOGIN.path, className: "text-white", style: { textDecoration: "underline" } },
                                                    React.createElement(FormattedMessage, { id: "page.createaccount.login" })),
                                                ".")))))))))));
    };
    /**
     *
     * @param user
     */
    ForgotPassword.prototype.onSuccess = function (user) {
        this.setState({ submitting: false });
        this.props.router.navigate(Routes.LOGIN.getPath());
        var intl = this.props.intl;
        Signals.ShowAlertModal.dispatch(intl.formatMessage({ id: 'createaccount.success.alert.title' }), intl.formatMessage({ id: 'createaccount.success.alert.body' }, { email: this.state.email }), intl.formatMessage({ id: 'createaccount.success.alert.ok' }));
    };
    /**
     *
     * @param error
     */
    ForgotPassword.prototype.onError = function (error) {
        this.setState({ submitting: false });
        createErrorResponse(this, error);
    };
    /**
     *
     * @param event
     */
    ForgotPassword.prototype.onSubmit = function (event) {
        event.preventDefault();
        if (this.state.submitting) {
            return;
        }
        var user = new UserModel(this.state);
        var command = new CreateUserCommand();
        command.execute(user, true).then(this.onSuccess).catch(this.onError);
        this.setState({ errors: null, submitting: true });
    };
    /**
     *
     * @param e
     */
    ForgotPassword.prototype.onInputChange = function (e) {
        var nextState = {};
        nextState[e.target.name] = e.target.value;
        switch (e.target.name) {
            case 'email':
                nextState[e.target.name] = e.target.value.toLowerCase();
                break;
            case 'password':
                this.checkIfPasswordsMatch(e.target.value, this.state.passwordMatch);
                nextState['password'] = e.target.value;
                break;
            case 'passwordMatch':
                this.checkIfPasswordsMatch(this.state.password, e.target.value);
                nextState[e.target.name] = e.target.value;
                break;
            default:
                nextState[e.target.name] = e.target.value;
        }
        this.setState(nextState);
    };
    /**
     *
     * @return {boolean}
     */
    ForgotPassword.prototype.fieldsComplete = function () {
        var _a = this.state, firstname = _a.firstname, lastname = _a.lastname, email = _a.email, password = _a.password;
        return (firstname && firstname.length > 0) && (lastname && lastname.length > 0) && (email && email.length > 0) && validPassword(password);
    };
    /**
     *
     * @param password
     * @param match
     */
    ForgotPassword.prototype.checkIfPasswordsMatch = function (password, match) {
        if (password == match) {
            this.setState({ matchingPasswords: true, errors: [] });
        }
        else {
            var err = { password: [" "], passwordMatch: ["error.passwordsDontMatch"] };
            this.setState({ matchingPasswords: false, errors: err });
        }
    };
    return ForgotPassword;
}(React.Component));
ForgotPassword.contextType = ApplicationContext;
export default injectIntl(withRouter(ForgotPassword));
